import type { InputHTMLAttributes } from "react";
import clsx from "clsx";
import { GdRichTextEditableSurface } from "@/components/ui/GdRichTextContentEditable";

type GdRichTextInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type" | "value" | "onChange"> & {
  value?: string;
  onChange?: (event: { target: { value: string } }) => void;
};

export function GdRichTextInput({
  value,
  onChange,
  className,
  disabled,
  placeholder,
  id,
  ...rest
}: GdRichTextInputProps) {
  return (
    <GdRichTextEditableSurface
      value={value}
      onChange={(next) => {
        onChange?.({ target: { value: next } });
      }}
      disabled={disabled}
      multiline={false}
      className={clsx("w-full", className)}
      placeholder={placeholder}
      id={id}
      aria-label={rest["aria-label"]}
    />
  );
}
